import PrimaryModal from './PrimaryModal';

export default PrimaryModal;
